import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  downloadModalSubtitle: {
    marginTop: 0,
    fontWeight: 600,
    fontSize: 14,
  },
});
